<div class="chat-title-bar">
  <div
    class="chat-info"
    [attr.aria-label]="(selectedConversation ? 'agent.title.chatActive' : 'agent.title.noChatActive') | translate"
  >
    <div class="info-row">
      <div class="main-info">
        <div class="chat-title-row">
          <span class="chat-title">
            <i
              class="pi pi-comments"
              style="margin-right: 4px; color: #fff"
            ></i>
            {{ 'agent.title.chat' | translate }}
          </span>
          <span class="chat-id" *ngIf="selectedConversation">
            <i class="pi pi-hashtag" style="margin-right: 2px"></i>
            {{ selectedConversation.conversationId }}
          </span>
        </div>
        
        <span class="chat-subtitle">{{ getCampaignValue(customVars) }}</span>
        <span
          class="user-info"
          *ngIf="selectedConversation?.customVariables?.['Nombres'] || selectedConversation?.customVariables?.['Apellidos']"
        >
          <strong>{{ 'agent.title.user' | translate }}</strong>
          {{ selectedConversation?.customVariables?.["Nombres"] }}
          {{ selectedConversation?.customVariables?.["Apellidos"] }}
        </span>
        <span
          class="user-info"
          *ngIf="selectedConversation?.customVariables?.['Identificacion']"
        >
          {{ selectedConversation?.customVariables?.["Identificacion"] }}
        </span>
        <span
          class="user-info"
          *ngIf="selectedConversation?.customVariables?.['Nit']"
        >
          {{ selectedConversation?.customVariables?.["Nit"] }}
        </span>
        <div style="color: #fff; font-size: 0.8rem">
          <span class="agent-name">
            <strong>{{ 'agent.title.currentAgent' | translate }}</strong>
            {{ selectedConversation?.agentName }}
          </span>
        </div>
      </div>
      <div class="side-info">
        <div class="timer-transfer-row">
          <div
            *ngIf="selectedConversation?.transferData?.isTransfer"
            class="transfer-info"
          >
            <span class="transfer-label">{{ 'agent.title.chatTransferred' | translate }}</span>
            <div class="transfer-details">
              <strong style="color: #fff">{{ 'agent.title.transferredBy' | translate }}</strong>
              <div>
                {{ selectedConversation?.transferData?.transferByAgent }}
              </div>

              <div>
                <strong style="color: #fff; margin-right: 5px"
                  >{{ 'agent.title.fromCampaign' | translate }}
                </strong>
                {{ selectedConversation?.transferData?.transferByCampaign }}
              </div>
            </div>
          </div>
        </div>
        @if (!selectedConversation?.transferData) {
        <span class="agent-name">
          <strong>{{ 'agent.title.currentAgent' | translate }}</strong> {{ selectedConversation?.agentName }}
        </span>
        }
      </div>
    </div>
  </div>
  <div class="timer-actions-row">
    <div class="timer-actions-inner">
      <div *ngIf="selectedConversation?.startDate" class="timer-container">
        <span class="timer-label">⏱</span>
        <span class="timer-value">{{ elapsedTime }}</span>
      </div>
        
      <div class="chat-title-actions">
         <ng-container *ngIf="canTransferAgent">
          <p-button
            icon="pi pi-arrows-h"
            styleClass="p-button-rounded p-button-text axede-toggle-button"
            (click)="onTransferAgent()"
            [pTooltip]="'agent.title.transferTooltip' | translate"
            tooltipPosition="left"
            [attr.aria-label]="'agent.title.transferAgentsAria' | translate"
          ></p-button>
        </ng-container>
        <p-button
          icon="pi pi-copy"
          styleClass="p-button-rounded p-button-text axede-toggle-button"
          (click)="copyTranscriptToClipboard()"
          tooltipPosition="left"
          [pTooltip]="'agent.title.copyTranscript' | translate"
          [attr.aria-label]="'agent.title.copyTranscript' | translate"
          [disabled]="!chatMessages.length"
        ></p-button>
        <ng-container *ngIf="selectedConversation?.metadata?.translationConfig?.enable">
          <p-button
            [icon]="isTranslationEnabled ? 'pi pi-globe' : 'pi pi-language'"
            styleClass="p-button-rounded p-button-text axede-toggle-button"
            (click)="onToggleTranslation()"
            [pTooltip]="(isTranslationEnabled ? 'agent.title.showOriginal' : 'agent.title.showTranslated') | translate"
            tooltipPosition="left"
            [attr.aria-label]="'agent.title.changeLanguage' | translate"
          ></p-button>
        </ng-container>
        <p-button
          [icon]="isInfoPanelVisible ? 'pi pi-comments' : 'pi pi-info-circle'"
          styleClass="p-button-rounded p-button-text axede-toggle-button"
          (click)="onToggleInfoPanel()"
          [pTooltip]="(isInfoPanelVisible ? 'agent.title.viewChat' : 'agent.title.viewInfo') | translate"
          tooltipPosition="left"
          [attr.aria-label]="'agent.title.changeView' | translate"
        ></p-button>
        <p-dropdown
          [options]="closeReasons"
          [(ngModel)]="selectedCloseReason"
          [placeholder]="'agent.title.closeConversation' | translate"
          (onChange)="onCloseReasonChange($event)"
          [style]="{ 'min-width': '180px' }"
          styleClass="p-button-sm axede-dropdown"
          [ariaLabel]="'agent.title.closeConversation' | translate"
          [disabled]="!selectedConversation"
          [showClear]="true"
        ></p-dropdown>
      </div>
    </div>
  </div>
</div>
